import React from "react";
import ContentPage, { Block, BulletList } from "../components/ContentPage";

export default function FamilieplanPage() {
  return (
    <ContentPage
      title="Iedere maand ondersteuning sturen"
      lead="Wil je regelmatig boodschappen of benodigdheden voor iemand bestellen? Met het Suriwebwinkel Familieplan kun je eenvoudig een terugkerend pakket samenstellen."
      ctaLabel="Ontdek het Familieplan"
      secondaryLabel="Bekijk pakketten"
      secondaryTo="/pakketten"
    >
      <Block title="Kies wat bij jou past">
        <BulletList
          items={[
            "De ontvanger",
            "Het gewenste budget",
            "De producten of het pakket",
            "Hoe vaak je wilt bestellen",
            "De gewenste bezorgperiode",
          ]}
        />
        <p>
          Je ontvangt vooraf een herinnering en kunt de bestelling controleren
          voordat deze wordt verwerkt. Zo kun je vanuit Europa structureel
          ondersteuning bieden zonder iedere maand opnieuw te beginnen.
        </p>
      </Block>
    </ContentPage>
  );
}
